/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCURRENCY = {
    Zar: 'ZAR'
} as const;
export type IAPCURRENCY = typeof IAPCURRENCY[keyof typeof IAPCURRENCY];


export function IAPCURRENCYFromJSON(json: any): IAPCURRENCY {
    return IAPCURRENCYFromJSONTyped(json, false);
}

export function IAPCURRENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCURRENCY {
    return json as IAPCURRENCY;
}

export function IAPCURRENCYToJSON(value?: IAPCURRENCY | null): any {
    return value as any;
}

